import { Link } from "react-router-dom";
import { ArrowRight, Lock } from "lucide-react";
import { EvidenceBadge } from "@/components/common/EvidenceBadge";

export function CatalogueCard({ cap, compact = false }) {
  return (
    <Link
      to={`/capabilities/${cap.slug}`}
      data-testid={`catalogue-card-${cap.slug}`}
      className={`card-lift flex flex-col rounded-2xl border border-[var(--line)] bg-[var(--paper)] ${compact ? "p-5" : "p-7"}`}
    >
      <div className="flex items-start justify-between gap-3">
        <span className="font-mono text-[0.68rem] uppercase tracking-wide text-[var(--mineral)]">{cap.domain}</span>
        <EvidenceBadge status={cap.evidence_status} />
      </div>
      <h3 className={`mt-3 font-display font-bold text-navy ${compact ? "text-base" : "text-lg"}`}>{cap.title}</h3>
      {!compact && <p className="mt-3 flex-1 text-sm text-[var(--mineral)]">{cap.summary}</p>}
      <div className="mt-4 flex flex-wrap gap-2">
        {(cap.methods || []).slice(0, 3).map((m) => (
          <span key={m} className="rounded-full border border-[var(--line)] bg-[var(--ivory)] px-2.5 py-1 font-mono text-[0.66rem] text-[var(--mineral)]">{m}</span>
        ))}
      </div>
      <div className="mt-5 flex items-center justify-between border-t border-[var(--line)] pt-3">
        <span className="flex items-center gap-1.5 font-mono text-xs text-[var(--mineral)]">
          {cap.access_status !== "Public" && <Lock size={12} />}
          {cap.readiness}
        </span>
        <span className="inline-flex items-center gap-1 text-sm font-semibold text-[var(--cobalt)]">Detail <ArrowRight size={14} /></span>
      </div>
    </Link>
  );
}
